import { render } from "./HoverbitDocsPage.vue?vue&type=template&id=6e7bd0f4&scoped=true"
import script from "./HoverbitDocsPage.vue?vue&type=script&lang=js"
export * from "./HoverbitDocsPage.vue?vue&type=script&lang=js"

import "./HoverbitDocsPage.vue?vue&type=style&index=0&id=6e7bd0f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e7bd0f4"]])

export default __exports__